/* eslint-disable */
import { Chip, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import BreachTabs from './BreachTabs'
import { useApiGet } from '../../apiCalls/useApi'
import { getBreachDetails } from '../../apiCalls/breachApi'
import LoadingCircle from '../../components/LoadingCircle.tsx'

export default function BreachManagementMainPage() {
  const { breachId, breachName } = useLocation().state
  const [breachDetails, setBreachDetails] = useState<any>(null)
  const fetchBreachDetails = useApiGet(getBreachDetails)
  const [isLoading, setIsLoading] = useState(false)
  const [needUpdate, setNeedUpdate] = useState<number>(0)
  const [statusList, setStatusList] = useState([
    {
      statusName: 'Investigation Status',
      status: 'In Progress',
    },
    {
      statusName: 'Containment Status',
      status: 'Completed',
    },
    {
      statusName: 'Remediation Status',
      status: 'In Progress',
    },
    {
      statusName: 'Report to Authorities Status',
      status: 'In Progress',
    },
    {
      statusName: 'Report to Affected Organizations Status',
      status: 'Completed',
    },
    {
      statusName: 'Notification to Affected Clients Status',
      status: 'In Progress',
    },
    {
      statusName: 'Additional Actions Status',
      status: 'In Progress',
    },
  ])

  const processStatusList = (data:any) => {
    const statusList = [
      {
        statusName: 'Investigation Status',
        status: data.investigationStatus,
      },
      {
        statusName: 'Containment Status',
        status: data.containmentStatus,
      },
      {
        statusName: 'Remediation Status',
        status: data.remediationStatus,
      },
      {
        statusName: 'Report to Authorities Status',
        status: data.reportToAuthoritiesStatus,
      },
      {
        statusName: 'Report to Affected Organizations Status',
        status: data.reportToAffectedOrganizationsStatus,
      },
      {
        statusName: 'Notification to Affected Clients Status',
        status: data.notificationToAffectedClientsStatus,
      },
      {
        statusName: 'Additional Actions Status',
        status: data.additionalActionsStatus,
      },
    ]
    return statusList
  }

  useEffect(() => {
    setIsLoading(true)
    fetchBreachDetails({ breachId }).then((res) => {
      if (!res || !res?.data || res.error) return
      setBreachDetails(res.data)
      const statusList = processStatusList(res.data.breachInfo)
      setStatusList(statusList)
      setIsLoading(false)
    })
  }, [breachId, needUpdate])



  if (isLoading)
    return (
      <Paper
        elevation={0}
        className='paperStyle'
        sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}
      >
        <LoadingCircle />
      </Paper>
    )

  return (
    <Paper elevation={0} className='paperStyle'>
      <div style={{ height: '100%' }}>
        <div
          style={{
            height: '230px',
            border: '2px solid gray',
            borderRadius: '6px',
            padding: '16px',
            boxSizing: 'border-box',
            width: '100%',
          }}
        >
          <div>
            <Typography variant='h6'>{`${breachName} (${breachId}) Status`}</Typography>
          </div>
          <div
            style={{
              width: '100%',
              height: '210px',
              flexWrap: 'wrap',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            {statusList.map((status) => (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '500px',
                  height: '35px',
                }}
              >
                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{status.statusName}</div>
                <Chip
                  label={status.status === 'true' ? 'Completed' : 'In Progress'}
                  sx={{
                    fontSize: '12px',
                  }}
                  color={status.status === 'true' ? 'success' : 'primary'}
                />
              </div>
            ))}
          </div>
        </div>
        <BreachTabs breachDetails={breachDetails} setNeedUpdate={setNeedUpdate} />
      </div>
    </Paper>
  )
}
